import { render, staticRenderFns } from "./GoalMarker.vue?vue&type=template&id=1cd98526&scoped=true&lang=pug&"
import script from "./GoalMarker.vue?vue&type=script&lang=js&"
export * from "./GoalMarker.vue?vue&type=script&lang=js&"
import style0 from "./GoalMarker.vue?vue&type=style&index=0&id=1cd98526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd98526",
  null
  
)

export default component.exports